"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PromoteFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14.9730668,3.57284121 L14.993234,3.66805515 L15,3.765146 L15,12.234854 C15,12.6214533 14.6865993,12.934854 14.3,12.934854 L14.2029092,12.928088 L14.1076952,12.9079208 L8.221,11.2249658 L8.92454936,13.7295819 C9.07389717,14.2612901 8.76393277,14.8133952 8.23222451,14.962743 C8.14421188,14.9874642 8.05322501,15 7.96180639,15 L7.00746674,15 C6.55978086,15 6.16664342,14.702452 6.04505474,14.2715937 L5.11920166,11 L5,11 C3.9456382,11 3.08183488,10.1841222 3.00548574,9.14926234 L3,9 L3,7 C3,5.9456382 3.81587779,5.08183488 4.85073766,5.00548574 L5,5 L7.429,5 L14.1076952,3.09207923 C14.4794197,2.98587223 14.8668598,3.2011167 14.9730668,3.57284121 Z" })));
};
PromoteFilledSmall.displayName = 'PromoteFilledSmall';
exports.default = PromoteFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PromoteFilledSmall.js.map